import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';

import useConversationContext from 'pages/Messages/hook';
import { ContactModal } from 'components/Modals'
import { setContactModal } from 'redux/actions/app'

const useStyles = makeStyles((theme) => ({
    root: {
        transform: 'translateZ(0px)',
        flexGrow: 1,
        position: 'fixed',
        right: 30,
        bottom: 30,
        zIndex: 9999
    },
    popover: {
        minWidth: 200,
        backgroundColor: theme.palette.app.background,
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(4),
        borderRadius: 10
    },
    title: {
        color: theme.palette.app.background,
    },
    avatar: {
        minWidth: 'auto',
        marginRight: theme.spacing(1.5)
    },
    iconstyle: {
        fill: theme.palette.app.primary,
        width: 18,
        height: 18
    },
    largeIconstyle: {
        fill: 'white',
        width: 25,
        height: 25
    },
    pinBtn: {
        padding: 2,
        '&:hover': {
            backgroundColor: 'transparent !important',
            fill: 'inherit !important',
            color: 'inherit !important'
        }
    },
    pinIcon: {
        width: 18,
        height: 18
    },
    menuBtn: {
        marginRight: theme.spacing(1),
        boxShadow: '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
        backgroundColor: theme.palette.app.primary,
        fill: 'white',
        color: 'white',
        padding: 12
    },
    dialicon: {
        color: 'white',
        fill: 'white',
    },
    dialinIcon: {
        width: 40,
        height: 40,
        color: 'white',
        fill: 'white',
    },
    menutext: {
        fontWeight: '500 !important'
    }
}));

function FabButton() {
    const classes = useStyles();
    const { loadChannels } = useConversationContext()
    const { openContactModal } = useSelector(state => state.app)
    const dispatch = useDispatch()

    return (
        <div className={classes.root}>
            <ContactModal
                appId="0000"
                visible={openContactModal}
                onClose={(refresh) => {
                    dispatch(setContactModal(false))
                    if (refresh) {
                        loadChannels()
                    }
                }}
            />
        </div>
    );
}
export default injectIntl(FabButton)